// Legacy URL: /locations → /service-areas (301 redirect).
//
// Removed 2026-04 — /service-areas is the canonical city index. Preserved
// as a redirect to consolidate any inbound links onto the canonical URL.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/locations")({
  beforeLoad: () => {
    throw redirect({ to: "/service-areas", statusCode: 301 });
  },
});
